import React from 'react';
import { ComponentProps } from 'types/index';
import { useMobileOrder } from 'lib/hooks/useMobileOrder';
import { useUserOrderStore } from 'lib/store/userOrderStore';
import { addReportPublicParams, report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import './index.scss';

export default function OrderHotSpot({ data, commonStyle }: ComponentProps<any>) {
  const { activityId } = data;
  const { orderFlowPackage } = useMobileOrder();
  const { isSubscriber } = useUserOrderStore((state) => ({
    isSubscriber: state.userOrderInfo.isSubscriber,
  }));

  const handleOrder = () => {
    if (isSubscriber) return;
    addReportPublicParams({
      orderTriggerType: 'hot_spot',
    });
    report(ATTA_REPORT.ORDER.ORDER_CLICK);
    orderFlowPackage(+activityId);
  };

  return <div style={commonStyle} className="order-hot-spot" onClick={handleOrder} />;
}
